"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectInfo = void 0;
const three_1 = require("three");
const ObjectInfoControls_1 = require("./components/ObjectInfoControls");
const DEVIATION = 0.01;
class ObjectInfo {
    constructor(webgl, type, parentEl, objectUuid) {
        this.eventSubscriptions = [];
        this.objectInfoFunctions = {
            // nameChange: () => this.updateName(),
            positionXChange: () => this.updatePosition(),
            positionYChange: () => this.updatePosition(),
            positionZChange: () => this.updatePosition(),
            rotationXChange: () => this.updateRotation(),
            rotationYChange: () => this.updateRotation(),
            rotationZChange: () => this.updateRotation(),
            scaleXChange: () => this.updateScale(),
            scaleYChange: () => this.updateScale(),
            scaleZChange: () => this.updateScale(),
        };
        this.updatePosition = () => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            const object = (_a = this.webgl) === null || _a === void 0 ? void 0 : _a.selected;
            if (!object) {
                return;
            }
            const stringPosX = (_c = (_b = this.objectInfoControls) === null || _b === void 0 ? void 0 : _b.positionXInput) === null || _c === void 0 ? void 0 : _c.value;
            const stringPosY = (_e = (_d = this.objectInfoControls) === null || _d === void 0 ? void 0 : _d.positionYInput) === null || _e === void 0 ? void 0 : _e.value;
            const stringPosZ = (_g = (_f = this.objectInfoControls) === null || _f === void 0 ? void 0 : _f.positionZInput) === null || _g === void 0 ? void 0 : _g.value;
            const positionX = stringPosX ? parseFloat(stringPosX) : undefined;
            const positionY = stringPosY ? parseFloat(stringPosY) : undefined;
            const positionZ = stringPosZ ? parseFloat(stringPosZ) : undefined;
            const newPosition = new three_1.Vector3(positionX, positionY, positionZ);
            object.position.copy(newPosition);
            (_h = this.webgl) === null || _h === void 0 ? void 0 : _h.renderOnce();
        };
        this.updateRotation = () => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            const object = (_a = this.webgl) === null || _a === void 0 ? void 0 : _a.selected;
            if (!object) {
                return;
            }
            const stringRotX = (_c = (_b = this.objectInfoControls) === null || _b === void 0 ? void 0 : _b.rotationXInput) === null || _c === void 0 ? void 0 : _c.value;
            const stringRotY = (_e = (_d = this.objectInfoControls) === null || _d === void 0 ? void 0 : _d.rotationYInput) === null || _e === void 0 ? void 0 : _e.value;
            const stringRotZ = (_g = (_f = this.objectInfoControls) === null || _f === void 0 ? void 0 : _f.rotationZInput) === null || _g === void 0 ? void 0 : _g.value;
            const rotationX = stringRotX ? parseFloat(stringRotX) * three_1.MathUtils.DEG2RAD : undefined;
            const rotationY = stringRotY ? parseFloat(stringRotY) * three_1.MathUtils.DEG2RAD : undefined;
            const rotationZ = stringRotZ ? parseFloat(stringRotZ) * three_1.MathUtils.DEG2RAD : undefined;
            const newRotation = new three_1.Euler(rotationX, rotationY, rotationZ);
            const rotationVector = new three_1.Vector3();
            const newRotationVector = new three_1.Vector3();
            rotationVector.setFromEuler(object.rotation);
            newRotationVector.setFromEuler(newRotation);
            if (rotationVector.distanceTo(newRotationVector) >= DEVIATION) {
                object.rotation.copy(newRotation);
                (_h = this.webgl) === null || _h === void 0 ? void 0 : _h.renderOnce();
            }
        };
        this.updateScale = () => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            const object = (_a = this.webgl) === null || _a === void 0 ? void 0 : _a.selected;
            if (!object) {
                return;
            }
            const stringScaX = (_c = (_b = this.objectInfoControls) === null || _b === void 0 ? void 0 : _b.scaleXInput) === null || _c === void 0 ? void 0 : _c.value;
            const stringScaY = (_e = (_d = this.objectInfoControls) === null || _d === void 0 ? void 0 : _d.scaleYInput) === null || _e === void 0 ? void 0 : _e.value;
            const stringScaZ = (_g = (_f = this.objectInfoControls) === null || _f === void 0 ? void 0 : _f.scaleZInput) === null || _g === void 0 ? void 0 : _g.value;
            const scaleX = stringScaX ? parseFloat(stringScaX) : undefined;
            const scaleY = stringScaY ? parseFloat(stringScaY) : undefined;
            const scaleZ = stringScaZ ? parseFloat(stringScaZ) : undefined;
            const newScale = new three_1.Vector3(scaleX, scaleY, scaleZ);
            if (object.scale.distanceTo(newScale) >= DEVIATION) {
                object.scale.copy(newScale);
                (_h = this.webgl) === null || _h === void 0 ? void 0 : _h.renderOnce();
            }
        };
        this.update = (data) => {
            if (!data) {
                return;
            }
            if ((data === null || data === void 0 ? void 0 : data.uuid) !== this.objectUuid) {
                return;
            }
            if (this.type === 'light' && !(data === null || data === void 0 ? void 0 : data.type.includes('Light'))) {
                return;
            }
            this.updateUI(data);
        };
        this.updateUI = (object) => {
            this.updateTransformUi(object);
        };
        this.updateTransformUi = (object) => {
            // if (object.uuid !== this.objectUuid) {
            // 	return;
            // }
            this.objectInfoControls.positionXInput.value = object.position.x.toString();
            this.objectInfoControls.positionYInput.value = object.position.y.toString();
            this.objectInfoControls.positionZInput.value = object.position.z.toString();
            this.objectInfoControls.rotationXInput.value = (object.rotation.x * three_1.MathUtils.RAD2DEG).toString();
            this.objectInfoControls.rotationYInput.value = (object.rotation.y * three_1.MathUtils.RAD2DEG).toString();
            this.objectInfoControls.rotationZInput.value = (object.rotation.z * three_1.MathUtils.RAD2DEG).toString();
            this.objectInfoControls.scaleXInput.value = object.scale.x.toString();
            this.objectInfoControls.scaleYInput.value = object.scale.y.toString();
            this.objectInfoControls.scaleZInput.value = object.scale.z.toString();
        };
        this.webgl = webgl;
        this.type = type;
        this.objectUuid = objectUuid;
        this.parentEl = parentEl;
        if (!parentEl) {
            throw new Error("Parent element navigationControl is undefined");
        }
        this.objectInfoControls = new ObjectInfoControls_1.ObjectInfoControls2(this.parentEl);
        this.addEvents();
    }
    dispose() {
        var _a;
        this.removeEvents();
        (_a = this.objectInfoControls) === null || _a === void 0 ? void 0 : _a.dispose();
        delete this.objectInfoControls;
        delete this.webgl;
    }
    addEvents() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        // this.objectInfoControls?.objectName?.setEvent('change', this.objectInfoFunctions.nameChange);
        (_b = (_a = this.objectInfoControls) === null || _a === void 0 ? void 0 : _a.positionXInput) === null || _b === void 0 ? void 0 : _b.addEventListener('change', this.objectInfoFunctions.positionXChange);
        (_d = (_c = this.objectInfoControls) === null || _c === void 0 ? void 0 : _c.positionYInput) === null || _d === void 0 ? void 0 : _d.addEventListener('change', this.objectInfoFunctions.positionYChange);
        (_f = (_e = this.objectInfoControls) === null || _e === void 0 ? void 0 : _e.positionZInput) === null || _f === void 0 ? void 0 : _f.addEventListener('change', this.objectInfoFunctions.positionZChange);
        (_h = (_g = this.objectInfoControls) === null || _g === void 0 ? void 0 : _g.rotationXInput) === null || _h === void 0 ? void 0 : _h.addEventListener('change', this.objectInfoFunctions.rotationXChange);
        (_k = (_j = this.objectInfoControls) === null || _j === void 0 ? void 0 : _j.rotationYInput) === null || _k === void 0 ? void 0 : _k.addEventListener('change', this.objectInfoFunctions.rotationYChange);
        (_m = (_l = this.objectInfoControls) === null || _l === void 0 ? void 0 : _l.rotationZInput) === null || _m === void 0 ? void 0 : _m.addEventListener('change', this.objectInfoFunctions.rotationZChange);
        (_p = (_o = this.objectInfoControls) === null || _o === void 0 ? void 0 : _o.scaleXInput) === null || _p === void 0 ? void 0 : _p.addEventListener('change', this.objectInfoFunctions.scaleXChange);
        (_r = (_q = this.objectInfoControls) === null || _q === void 0 ? void 0 : _q.scaleYInput) === null || _r === void 0 ? void 0 : _r.addEventListener('change', this.objectInfoFunctions.scaleYChange);
        (_t = (_s = this.objectInfoControls) === null || _s === void 0 ? void 0 : _s.scaleZInput) === null || _t === void 0 ? void 0 : _t.addEventListener('change', this.objectInfoFunctions.scaleZChange);
        const subscriptions = [
            PubSub.subscribe("object-info" /* OBJECT_INFO */, (_, data) => this.update(data)),
            PubSub.subscribe("model-transform-change" /* MODEL_TRANSFORM_CHANGE */, (_, data) => this.updateTransformUi(data))
        ];
        this.eventSubscriptions.push(...subscriptions);
    }
    removeEvents() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        (_b = (_a = this.objectInfoControls) === null || _a === void 0 ? void 0 : _a.positionXInput) === null || _b === void 0 ? void 0 : _b.removeEventListener('change', this.objectInfoFunctions.positionXChange);
        (_d = (_c = this.objectInfoControls) === null || _c === void 0 ? void 0 : _c.positionYInput) === null || _d === void 0 ? void 0 : _d.removeEventListener('change', this.objectInfoFunctions.positionYChange);
        (_f = (_e = this.objectInfoControls) === null || _e === void 0 ? void 0 : _e.positionZInput) === null || _f === void 0 ? void 0 : _f.removeEventListener('change', this.objectInfoFunctions.positionZChange);
        (_h = (_g = this.objectInfoControls) === null || _g === void 0 ? void 0 : _g.rotationXInput) === null || _h === void 0 ? void 0 : _h.removeEventListener('change', this.objectInfoFunctions.rotationXChange);
        (_k = (_j = this.objectInfoControls) === null || _j === void 0 ? void 0 : _j.rotationYInput) === null || _k === void 0 ? void 0 : _k.removeEventListener('change', this.objectInfoFunctions.rotationYChange);
        (_m = (_l = this.objectInfoControls) === null || _l === void 0 ? void 0 : _l.rotationZInput) === null || _m === void 0 ? void 0 : _m.removeEventListener('change', this.objectInfoFunctions.rotationZChange);
        (_p = (_o = this.objectInfoControls) === null || _o === void 0 ? void 0 : _o.scaleXInput) === null || _p === void 0 ? void 0 : _p.removeEventListener('change', this.objectInfoFunctions.scaleXChange);
        (_r = (_q = this.objectInfoControls) === null || _q === void 0 ? void 0 : _q.scaleYInput) === null || _r === void 0 ? void 0 : _r.removeEventListener('change', this.objectInfoFunctions.scaleYChange);
        (_t = (_s = this.objectInfoControls) === null || _s === void 0 ? void 0 : _s.scaleZInput) === null || _t === void 0 ? void 0 : _t.removeEventListener('change', this.objectInfoFunctions.scaleZChange);
        this.eventSubscriptions.forEach((subscription) => PubSub.unsubscribe(subscription));
        this.eventSubscriptions = [];
    }
}
exports.ObjectInfo = ObjectInfo;
